const jobOpeningsApi = '/job-openings';

export const referralJobOpeningsPath = () => `${jobOpeningsApi}/list`;
